function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriberBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.69,433.76s-11.89,8.09-16.68,7.55a2.23,2.23,0,0,1-1.41-.6c-3.12-3.22-5.63-8.88-5.63-8.88s1.49-2.06,6.08,3.41l2.91-2.67-6-6.06s3.39-2.69,9.15.74c-.2-.42-3.91-8.5-1.11-19.5l-14-13.51,12.42-10.82,1-.84s.78.77,2,2,2.91,2.71,4.74,4.32c4.38,3.85,9.68,8,12,8C195.34,396.76,185.69,433.76,185.69,433.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.1,298s-3,22.32-18.29,31.05c-15.12,2.16-32.08-10.38-37.8-25.43-4.52-11.89-.57-25.38,1.59-31.15a0,0,0,0,1,0,0C355.47,262.26,392.1,298,392.1,298Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26,184.46c37.82-37.81,69.85-6.09,83.35-56.86C175.09,12.91,301.51,14,318.13,95.61c29.95,147,160.4,53.65,159.43,158.93-1,112.41-83.7,200-232,208.71C112.69,471.1-1.41,247.11,61.26,184.46Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26,184.46c37.82-37.81,69.85-6.09,83.35-56.86C175.09,12.91,301.51,14,318.13,95.61c29.95,147,160.4,53.65,159.43,158.93-1,112.41-83.7,200-232,208.71C112.69,471.1-1.41,247.11,61.26,184.46Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Discount--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.1,120c-.24-2,.67-3.29,2.62-3.52s3.13.78,3.37,2.82l.77,6.51c.23,2-.68,3.29-2.63,3.52s-3.13-.78-3.37-2.82Zm2.75,6.42c.11.88.52,1.2,1.17,1.13s1-.49.87-1.37l-.79-6.79c-.11-.88-.55-1.2-1.17-1.12s-1,.48-.87,1.36Zm7.7-10.71,1.84-.22-5.49,20.72-1.84.22Zm.21,10.39c-.24-2,.68-3.3,2.63-3.52s3.13.78,3.37,2.81l.76,6.51c.24,2-.67,3.29-2.63,3.52s-3.13-.78-3.37-2.82Zm2.76,6.41c.1.88.51,1.21,1.16,1.13s1-.49.88-1.37l-.8-6.79c-.1-.87-.54-1.19-1.16-1.12s-1,.49-.87,1.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.16,139.92,154,142.63a2,2,0,0,1-2.22-1.75L149,117a3,3,0,0,1,.85-2.44l9.66-9.51a2.93,2.93,0,0,1,3.59-.42l11.59,7a2.93,2.93,0,0,1,1.39,2.17l2.8,23.88A2,2,0,0,1,177.16,139.92Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.16,107.7a1.49,1.49,0,1,1-1.64-1.3A1.48,1.48,0,0,1,163.16,107.7Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69,91s4.52,17.4,0,16.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.54,104.4c.88-4.84,5.31-13,5.31-13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69,107.87a1.28,1.28,0,0,1-1.15-.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.86,97.43a29.31,29.31,0,0,1,9,12.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,112.87a29.33,29.33,0,0,1,44.08-17.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,142.35a29.18,29.18,0,0,1-9.75-17.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.29,149.55a29.26,29.26,0,0,1-15-4.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.45,116a29.33,29.33,0,0,1-24.76,33.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gift--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.9,217.27h37.57a0,0,0,0,1,0,0v22.57a1.66,1.66,0,0,1-1.66,1.66H88.55a1.66,1.66,0,0,1-1.66-1.66V217.27a0,0,0,0,1,0,0Z",
    transform: "matrix(0.98, 0.19, -0.19, 0.98, 45.33, -15.86)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,209.87h39.47a0,0,0,0,1,0,0v6a1.66,1.66,0,0,1-1.66,1.66H90.62A1.66,1.66,0,0,1,89,215.9v-6a0,0,0,0,1,0,0Z",
    transform: "translate(174.98 444.14) rotate(-169.09)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.72,
    y: 209.65,
    width: 5.37,
    height: 31.92,
    transform: "translate(44.63 -16.06) rotate(10.91)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,209.94s9.15-6.68,13.38-4.66,2.14,7.65,0,7.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.05,210.63s7.44-3.7,8.52-2-2.13,3.27-4.6,2.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68,209.48s3.86-7,3.36-9.26h2.57s.84,2.66-2.16,7.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,209.94s-6-9.6-10.69-9.29-4.82,6.3-2.69,6.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81,209.24s-5.53-6.21-7.16-5.05.77,3.82,3.24,4.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.37,209.42s-1-7.95.33-9.84l-2.4-1s-1.76,2.16-.66,7.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,198.7a37.41,37.41,0,0,1,7.71,18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,204.7a37.45,37.45,0,0,1,59.81-9.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,244a37.34,37.34,0,0,1-7.1-25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.57,258.07a37.28,37.28,0,0,1-17.35-10.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.61,224.8a37.45,37.45,0,0,1-40.23,34.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Megaphone--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.73,125.09l-3.14-1.6a9.92,9.92,0,0,0,.46-4.29c1,.48,2.06,1,3,1.43C293,121.92,292.92,123.44,292.73,125.09Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.3,122.69a11.32,11.32,0,0,0,3.16,1.06,28.5,28.5,0,0,1-2.57,18.09c-.81,1.58-9.32-2.78-8.52-4.36a37.52,37.52,0,0,0,3.36-12.39c.19-1.65.3-3.17.35-4.46C294.86,121.47,296.42,122.24,297.3,122.69Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,102.86a11.14,11.14,0,0,1-7,20.89,11.32,11.32,0,0,1-3.16-1.06c-.88-.45-2.44-1.22-4.22-2.06-1-.47-2-.95-3-1.43-2.46-1.13-4.84-2.17-6.07-2.57l10.76-21C297,97.27,304.93,101.57,307.45,102.86Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.31,85.69a53.57,53.57,0,0,0,10.43,9.92l-10.76,21A53.79,53.79,0,0,0,269.83,114l-4.17-.22,16-31.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.81,114.65,279.57,78a1.19,1.19,0,0,1,1.59-.51l1.38.71a1.19,1.19,0,0,1,.52,1.59l-1.37,2.67-16,31.33-1.36,2.67a1.18,1.18,0,0,1-1.59.51l-1.39-.71A1.17,1.17,0,0,1,260.81,114.65Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.37,
    y1: 91.8,
    x2: 254.14,
    y2: 88.1,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.84,
    y1: 80.2,
    x2: 265.28,
    y2: 72.22,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.92,
    y1: 105.45,
    x2: 247.79,
    y2: 106.42,
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.36,70.93A48.19,48.19,0,0,0,294.88,59.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.36,151A48.38,48.38,0,0,0,321.2,74.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.05,143.19a48.17,48.17,0,0,0,31.48,11.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,115.34a48.18,48.18,0,0,0,11.51,23.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53,58.08a48.38,48.38,0,0,0-48.38,48.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Heart--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.85,184.35c-4.06-3.63-8.27-2-10.42-.77-.43-2.46-2-6.7-7.36-7.42-5.86-.78-10.66,4.93-9.09,12.89,1.14,5.73,4.8,11,6.76,13.45.23.3.45.56.63.77l1,0c3.16-.13,9.52-.76,14.6-3.62C202,195.65,203.25,188.29,198.85,184.35Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.05,207s-.27.49-.64,1.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39,211.14c-1.6,5.23-2.7,14.19,5.82,19.62,21.06,13.43,28.15-18.25,12-15.4-11.09,2,.64,31.31,18,25.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2.9841089248657227,2.9841089248657227"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.66,240.21c.44-.2.89-.42,1.34-.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.69,433.76s-11.89,8.09-16.68,7.55a2.23,2.23,0,0,1-1.41-.6c-3.12-3.22-5.63-8.88-5.63-8.88s1.49-2.06,6.08,3.41l2.91-2.67-6-6.06s3.39-2.69,9.15.74c-.2-.42-3.91-8.5-1.11-19.5l-14-13.51,12.42-10.82,1-.84s.78.77,2,2,2.91,2.71,4.74,4.32c4.38,3.85,9.68,8,12,8C195.34,396.76,185.69,433.76,185.69,433.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.5,428.46s-6.78,7-7.49,12.85a2.23,2.23,0,0,1-1.41-.6c-3.12-3.22-5.63-8.88-5.63-8.88s1.49-2.06,6.08,3.41l2.91-2.67-6-6.06s3.39-2.69,9.15.74c-.2-.42-3.91-8.5-1.11-19.5l-14-13.51,12.42-10.82,3,1.13c1.23,1.16,2.91,2.71,4.74,4.32-2.63,3.85-8.26,11.82-8.26,11.82l4.87,6.6S172.77,423.93,176.5,428.46Z",
    style: {
      fill: "#8B5CF6",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.69,433.76s-11.89,8.09-16.68,7.55a2.23,2.23,0,0,1-1.41-.6c-3.12-3.22-5.63-8.88-5.63-8.88s1.49-2.06,6.08,3.41l2.91-2.67-6-6.06s3.39-2.69,9.15.74c-.2-.42-3.91-8.5-1.11-19.5l-14-13.51,12.42-10.82,1-.84s.78.77,2,2,2.91,2.71,4.74,4.32c4.38,3.85,9.68,8,12,8C195.34,396.76,185.69,433.76,185.69,433.76Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,432.57a14.8,14.8,0,0,1,3.13-5.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.79,339.58a33.89,33.89,0,0,1-6.73,7.26s0,0,0,0c-21.86,18.1-72.26,27-72.26,27s-1.69,2.53-4.29,6.13c-4.66,6.47-12.29,16.41-18.51,21.39h0c-2.63,2.11-5,3.33-6.81,3l9.46,34.93,4.23,15.16s-43.46,19-117.79-2.72c0,0-.85-9.7-.22-11.77,0-.1.06-.2.1-.31a13.74,13.74,0,0,1,2.92-3.66s-.42-6.24-.63-12.59a85,85,0,0,1,.15-12.15c.53-3.2,2.87-10.94,4.05-14.74l.69-2.21-3.7-34.64-1.06-10-.06-.52c0-.07,0-.15,0-.25l-.58-5.35-19.12,5.84s1,2.24,2.38,5.38c2.51,5.75,6.2,14.5,7,18a6.18,6.18,0,0,0,.24.84c1.77,5.05,8.51,9.64,8.51,9.64l-18.11,21.16-5.35-3.74a17,17,0,0,1-2.16,1.36c-3.52,1.91-10.9,4.72-19,.43a28.27,28.27,0,0,1-8.94-7.92C113,376.09,106.82,361,108.83,343.33s81.53-72.2,97.31-71.63l23.47,5.18c.51-.42,1.88-1.5,2.94-1.45,4.27.22,4.38,5.18,4.38,5.18l52.6,8.54s5.45-2.73,6.4-2.69a4.13,4.13,0,0,1,3.33,2.11s13.62-8.16,18-6.26C331.68,288.53,403.44,323.4,392.79,339.58Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.05,426a39.32,39.32,0,0,1-22.77,12.35c-2.77.44-5.2.88-7.33,1.32a13.74,13.74,0,0,1,2.92-3.66s-.42-6.24-.63-12.59C188.41,427.49,199.17,432.19,210.05,426Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.44,396.56l.69-2.21-3.7-34.64c5.53,7.93,25.25,34.94,38.84,37.86C236.48,400.61,198.49,406,186.44,396.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.63,439.34c-14.85-1.69-35.84-5.43-37.94-13.2C252.42,414,268.33,406.72,291,401.41c-2.63,2.11-5,3.33-6.81,3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,346.85c-21.86,18.1-72.26,27-72.26,27s-1.69,2.53-4.29,6.13a84.06,84.06,0,0,1-3.21-55.85s3.88,21,20,26c0,0-12.34-9.19-8-31.31,0,0,4.21,26,31.6,33.22C363.18,355.61,376.19,351.73,386.05,346.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.31,349.21l-.6-5.6-19.12,5.84s1,2.24,2.38,5.38c-7.31-.75-21.18,6-23.6-1.36-2.92-8.92,15-5.85,15-5.85l16.94-9.85c-3.2-13.7,4.95-24,4.95-24l1.55,9.56c.74-18.17,7.85-28.11,7.85-28.11C181.78,309.59,181.94,345,182.31,349.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.75,383.27l-18.11,21.16-5.35-3.74a17,17,0,0,1-2.16,1.36c-3.52,1.91-10.9,4.72-19,.43,5.87-8.12,18-20.07,32.41-24.68A144.48,144.48,0,0,0,159,394.24l3.72,3.66S172,387.32,180.75,383.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.72,290.07c0,1.87-1.18,23,14.22,28.63S268,314.81,268,314.81s-23.61,22.78-38,10.6S224.72,290.07,224.72,290.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.06,451.77s-.83-9.7-.21-11.76c.52-1.74,3-4,3-4s-1.31-19.66-.47-24.73c.72-4.35,4.74-17,4.74-17l-5.42-50.74-19.12,5.85s8.14,18,9.4,23.34,8.76,10.47,8.76,10.47l-18.11,21.15-5.35-3.73s-15.8,12.36-30.07-6.12-20.4-33.53-18.4-51.25,81.55-72.19,97.33-71.63l23.47,5.19c.5-.42,1.88-1.5,2.93-1.45,4.27.22,4.38,5.18,4.38,5.18l52.6,8.54s5.46-2.73,6.41-2.69a4.13,4.13,0,0,1,3.32,2.11s13.62-8.15,18-6.26c14.4,6.22,86.15,41.09,75.51,57.27-15.11,23-79,34.31-79,34.31s-21.25,32-29.62,30.52l13.69,50.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.2,343.09c24.14,15.94,43.6,13,58.83-7.52,0,0,12.68-16.35,11.78-34s-5.11-75.15-60.06-60.45c-9.05,2.42-30.16,30.69-31.93,38.46-.82,3.55-9.29,21.62-17.52,40.33",
    style: {
      fill: "#8B5CF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.89,174.16s15.38-2.33,26.06,7.23c13.51,12.09,28.68,44.69,7.08,98.71,0,0-31.91-21.18-86.37-7,0,0,4.69-12.67-3.54-52.56C211.4,202.49,220.76,160.91,271.89,174.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.58,309.72c22.76,3.69,46.94-21.51,46.94-21.51s-12.37-1.52-13.48-7.33c-3.55-18.33,10.73-41,10.73-41s-55.26,1.53-45.6,14a31.27,31.27,0,0,1,4.37,7.49c3.35,8.23,1,14.44-.75,16a2.41,2.41,0,0,1-.41.27c-3.34,1.52-17.07-.75-17.07-.75S227.81,306.35,248.58,309.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.69,295.19s-10.5,4.2-25.87,2.95l-6.92,3.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,301l-.5-4.54s-11.34-3.55-14.85-10.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.79,277.4c16.92,4.42,24.87-17.28,24.87-17.28s-13.54-4-24.12,1.32C254.89,269.67,252.57,275.88,250.79,277.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.75,228.49c4.11-23.11-.46-50.84-35.64-48.54-25.13,1.64-24.92,29.19-23.26,37.42,2.8,13.83-1.21,19.27,3.1,30.89,3.1,8.35,10.29,17.69,18.76,21.19,5.21,2.15,26.3-12.65,27.86-19.42",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,221.68c-.21,2.6-.52,9-6,13.76-3.56,3.07,4.6,6.21,4.6,6.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.71,212.51s-7.76-3.78-13,2.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.73,212a26.23,26.23,0,0,1,16.59.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.79,222.93c.24,2.23,1.74,3.9,3.35,3.72s2.72-2.12,2.48-4.35-1.74-3.89-3.35-3.72S264.55,220.7,264.79,222.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.53,249a43.65,43.65,0,0,0,17.35-6.34s.73,9.7-7.39,11.71c-6.23,1.55-8.64-5.56-8.64-5.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.35,188.75s-2.22,27.39,21.95,37.34l11.33-26.33-17.14-19-25.81-7.46c-38.57,2.41-55.17,26.37-33.76,90.22C227.92,263.55,221.93,187.51,271.35,188.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,227.25c-.34-3.08,7.45-10.92,10.08-5.89,4.49,8.58,1.22,16-3.42,19-2.08,1.31-4.72,3.77-6.57,1.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25,224c.25,2.23,1.75,3.9,3.36,3.72s2.72-2.12,2.48-4.35-1.75-3.9-3.36-3.72S241,221.72,241.25,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.5,219.46c-.29,1.85-.49,3.73-.6,5.6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.35,183.77c-19.54-.51-37.7,11.94-42,31.49",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.86,178.19s-28.18-6.63-38.74,12.06",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.72,210.75a30.21,30.21,0,0,0,6.07,6.4",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.54,181.84a76.12,76.12,0,0,0,8.94,25.46",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.85,266.6c-.5,2.24-1.09,4.46-1.75,6.66",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.22,229.36c4.57,10.15,4.26,22.78,2.38,33.46",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.87,247a27.29,27.29,0,0,1-7.95,20.88",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.88,185.11c4.79,6.48,8.35,13.43,13.9,19.35,5.85,6.23,11.7,13.37,12.8,22.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.12,178.37a21,21,0,0,1,3.76,3.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.51,328.75c-.56.12-1.12.22-1.7.3-15.12,2.16-32.08-10.38-37.8-25.43-4.52-11.89-.57-25.38,1.59-31.15.68-1.81,1.17-2.86,1.17-2.86,9.12-13,62.14,12.45,62.76,26.49S391,325.35,375.51,328.75Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.1,298s-3,22.32-18.29,31.05c-15.12,2.16-32.08-10.38-37.8-25.43-4.52-11.89-.57-25.38,1.59-31.15a0,0,0,0,1,0,0C355.47,262.26,392.1,298,392.1,298Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-32)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.1,298s-3,22.32-18.29,31.05c-15.12,2.16-32.08-10.38-37.8-25.43-4.52-11.89-.57-25.38,1.59-31.15a0,0,0,0,1,0,0C355.47,262.26,392.1,298,392.1,298Z",
    style: {
      fill: "#8B5CF6",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392.1,298s-3,22.32-18.29,31.05c-15.12,2.16-32.08-10.38-37.8-25.43-4.52-11.89-.57-25.38,1.59-31.15a0,0,0,0,1,0,0C355.47,262.26,392.1,298,392.1,298Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.57,309.75s17.22,24.72,37.33,26.78,33-14.88,33.79-27.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.89,198.2c1.51-4.23,12.37-2.81,15.82,10.39s17,45.29,17,45.29,54-79.41,63.64-82.47,5.85,10.7-7.08,29.79c0,0,12.11-2.13,15.29,0s1.63,15,3.32,19.46c2.84,7.53-3.47,9.12-3.47,9.12a13.47,13.47,0,0,1,8.43,3.21c3.47,3.25,1.73,16.68,2.72,20.48s-5.63,7-5.63,7,15.91,8.67,12.32,10.85c-6.06,3.66-9.51-.09-9.51-.09s-24.45,30.7-42.89,37.54-54.33-20.34-58.19-35.14.75-13.89-2.18-38.52S319.89,198.2,319.89,198.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.6,
    y: 156.39,
    width: 82.92,
    height: 142.69,
    rx: 4.72,
    transform: "translate(-45.12 103.46) rotate(-14.61)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.88,164.23a1.15,1.15,0,1,1-2.23.58,1.14,1.14,0,0,1,.82-1.41A1.16,1.16,0,0,1,357.88,164.23Z",
    style: {
      fill: "#8B5CF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.53,160.41a.72.72,0,0,1-.52.88.72.72,0,1,1,.52-.88Z",
    style: {
      fill: "#8B5CF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.6,
    y: 162.13,
    width: 9.49,
    height: 0.82,
    rx: 0.32,
    transform: "matrix(0.97, -0.25, 0.25, 0.97, -29.21, 97.14)",
    style: {
      fill: "#8B5CF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.24,154.12,435.57,282a2.8,2.8,0,0,1-2,3.41L363.38,303.7a2.8,2.8,0,0,1-3.41-2L326.64,173.82a2.8,2.8,0,0,1,2-3.41l14.41-3.76a2.34,2.34,0,0,1,2.51.92l1.05,1.49a2.34,2.34,0,0,0,2.51.92l31.63-8.24a2.35,2.35,0,0,0,1.74-2l.19-1.81a2.33,2.33,0,0,1,1.74-2l14.41-3.76A2.8,2.8,0,0,1,402.24,154.12Z",
    style: {
      fill: "#8B5CF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.51,
    cy: 214.1,
    r: 29.65,
    transform: "translate(30.75 475.08) rotate(-66.53)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.24,231.1a2.62,2.62,0,0,0,3.18,1.48l9.75-2.81a3.56,3.56,0,0,0,.12.62,4,4,0,1,0,7.76-2.25,4.24,4.24,0,0,0-.23-.59l9.74-2.81a2.63,2.63,0,0,0,1.91-3,2.54,2.54,0,0,0-3.22-2l-.82-.5a8.18,8.18,0,0,1-3.66-4.75l-1.85-6.41a11.37,11.37,0,0,0-12.56-8.1,3.09,3.09,0,1,0-3,.87A11.37,11.37,0,0,0,366,214.47l1.87,6.48a8.15,8.15,0,0,1-1,6.76h0A2.55,2.55,0,0,0,365.24,231.1Zm9.61-33.66a1.8,1.8,0,1,1-2.23-1.23A1.79,1.79,0,0,1,374.85,197.44Z",
    style: {
      fill: "#8B5CF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.05,
    y1: 227.71,
    x2: 379.75,
    y2: 228.96,
    style: {
      fill: "#8B5CF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.41,
    y1: 220.83,
    x2: 370.7,
    y2: 226.53,
    style: {
      fill: "#8B5CF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,260.66l-40,10.42A9,9,0,0,1,360,264.66h0a9,9,0,0,1,6.43-11l40-10.42a9,9,0,0,1,10.95,6.42h0A9,9,0,0,1,411,260.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.59,258.59a1.91,1.91,0,0,1,1.29-.91,1.88,1.88,0,0,1,1.57.17,2.28,2.28,0,0,1,.88,1.41l.07.26-1.23.32-.09-.34a1,1,0,0,0-.32-.58.62.62,0,0,0-.54-.06.59.59,0,0,0-.43.32,1,1,0,0,0,0,.66,1.59,1.59,0,0,0,.52.84,6,6,0,0,0,1.06.67,8.75,8.75,0,0,1,.94.55,3.06,3.06,0,0,1,.69.66,2.91,2.91,0,0,1,.48,1,2.27,2.27,0,0,1-.1,1.67,2.28,2.28,0,0,1-2.88.75,2.21,2.21,0,0,1-.9-1.41l-.13-.51,1.23-.32.15.59c.14.54.43.75.88.63s.61-.44.47-1a1.63,1.63,0,0,0-.52-.84,5.47,5.47,0,0,0-1.06-.66,10.61,10.61,0,0,1-.94-.56,3.06,3.06,0,0,1-.69-.66,2.82,2.82,0,0,1-.48-1A2.33,2.33,0,0,1,366.59,258.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.47,263.14c.14.53.44.74.89.63s.6-.45.46-1l-1.66-6.38,1.23-.32,1.64,6.29a2.27,2.27,0,0,1-.1,1.67,1.92,1.92,0,0,1-1.3.92,2,2,0,0,1-1.58-.16,2.35,2.35,0,0,1-.9-1.42l-1.64-6.29,1.3-.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.82,255.43a2,2,0,0,1,.84,1.32l.07.29a2.4,2.4,0,0,1,.07,1.11,1.38,1.38,0,0,1-.47.78c.71.08,1.19.59,1.43,1.51l.17.68a2,2,0,0,1-.12,1.59,2,2,0,0,1-1.34.88l-2,.54-2.16-8.27,2-.52A2.09,2.09,0,0,1,378.82,255.43Zm-1.37,3.45.51-.13a.79.79,0,0,0,.53-.35,1,1,0,0,0,0-.73l-.12-.46a1.05,1.05,0,0,0-.33-.6.6.6,0,0,0-.55-.07l-.63.16Zm1,3.73.74-.2a.65.65,0,0,0,.46-.31,1,1,0,0,0,0-.68l-.19-.72a1.26,1.26,0,0,0-.4-.73.85.85,0,0,0-.7-.06l-.58.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.5,255a1.86,1.86,0,0,1,1.29-.91,1.88,1.88,0,0,1,1.57.16,2.31,2.31,0,0,1,.89,1.42l.07.26-1.23.32-.09-.35a.92.92,0,0,0-.33-.57.6.6,0,0,0-.53-.07.61.61,0,0,0-.44.32,1,1,0,0,0,0,.66,1.58,1.58,0,0,0,.51.84,6.52,6.52,0,0,0,1.07.67c.38.2.69.39.94.55a3.54,3.54,0,0,1,.69.66,2.8,2.8,0,0,1,.47,1,2.22,2.22,0,0,1-.09,1.67,1.94,1.94,0,0,1-1.3.92,2,2,0,0,1-1.59-.16,2.3,2.3,0,0,1-.89-1.42l-.14-.5,1.23-.33.16.6c.14.53.43.74.88.62s.6-.44.46-1a1.59,1.59,0,0,0-.51-.83,5.57,5.57,0,0,0-1.07-.67,10.26,10.26,0,0,1-.93-.56,2.67,2.67,0,0,1-.69-.66,2.52,2.52,0,0,1-.48-1A2.3,2.3,0,0,1,380.5,255Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9,258.76a2.27,2.27,0,0,1-.1,1.67,1.93,1.93,0,0,1-1.3.91,1.91,1.91,0,0,1-1.58-.16,2.21,2.21,0,0,1-.9-1.41l-1.12-4.3a2.27,2.27,0,0,1,.09-1.67,1.94,1.94,0,0,1,1.3-.92,2,2,0,0,1,1.59.16,2.3,2.3,0,0,1,.89,1.42l.21.8-1.23.32-.23-.89c-.14-.54-.43-.75-.88-.63s-.6.44-.46,1l1.16,4.46c.14.54.43.75.88.63s.61-.44.47-1l-.31-1.18,1.23-.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.73,259.47a4.72,4.72,0,0,1-.19-.63l-.34-1.3a1.31,1.31,0,0,0-.41-.75.86.86,0,0,0-.72-.08l-.44.12.87,3.37-1.3.34-2.15-8.27,2-.52a1.72,1.72,0,0,1,2.42,1.4l.17.66a1.72,1.72,0,0,1-.41,1.89,1.24,1.24,0,0,1,.82.46,2.86,2.86,0,0,1,.5,1.08l.33,1.28c.06.23.12.42.17.56a1.6,1.6,0,0,0,.23.4l-1.32.35A1.57,1.57,0,0,1,393.73,259.47Zm-2.41-3.82.5-.13a.84.84,0,0,0,.54-.36,1,1,0,0,0,0-.72l-.22-.82a1,1,0,0,0-.32-.6.62.62,0,0,0-.56-.07l-.62.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.1,250.69l2.15,8.27-1.3.34L393.8,251Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.59,250a2,2,0,0,1,.83,1.31l.08.3a2.5,2.5,0,0,1,.07,1.1,1.44,1.44,0,0,1-.47.78c.71.09,1.18.59,1.43,1.52l.17.68a2,2,0,0,1-.12,1.58,2,2,0,0,1-1.34.89l-2,.53L396,250.44l2-.51A2.09,2.09,0,0,1,399.59,250Zm-1.37,3.45.51-.13a.85.85,0,0,0,.53-.35,1,1,0,0,0,0-.73l-.12-.46a1.12,1.12,0,0,0-.33-.61.65.65,0,0,0-.56-.07l-.62.17Zm1,3.72.74-.19a.68.68,0,0,0,.46-.32.94.94,0,0,0,0-.67l-.18-.72a1.29,1.29,0,0,0-.4-.74.86.86,0,0,0-.7-.05l-.58.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.83,251.87l.31,1.19-1.79.46.63,2.42,2.25-.58.31,1.18-3.55.92-2.15-8.27,3.54-.92.31,1.18-2.24.59.6,2.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.24,247.52a2,2,0,0,1,1.59.15,2.2,2.2,0,0,1,.88,1.39l1.09,4.19a2.17,2.17,0,0,1-.09,1.65,1.91,1.91,0,0,1-1.31.89l-2.06.54-2.16-8.27Zm1.09,7.29.73-.19a.67.67,0,0,0,.45-.32,1,1,0,0,0,0-.66l-1.12-4.3a1,1,0,0,0-.34-.57.67.67,0,0,0-.53-.06l-.74.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,373.89s-12.14-28.25-6-62.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.17,404.41s-24.54,7.5-27,13.15,11,.89,11,.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.26,288.57s-22.6,22.4-37.72,28.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.21,282.55s-4.12,30.24,11.25,35.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.71,343.61s-.12-39.64,7.75-51.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.77,303.22s-2.21,24.62,2.76,32.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.59,349.46s-17.19-5.92-20.75,1.42,10.25.83,10.25.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93,375.16s-16.88,9.51-17.75,14.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5,348.86s32.31,48.83,50.14,44.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.57,417.35s-25.33,18.57-29,17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,338.11c1.71-1.4,2.84-2.33,3.21-2.62C402.83,335.82,401.73,336.78,400,338.11Z",
    style: {
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriberBro);
export default __webpack_public_path__ + "static/media/Subscriber-bro.e82fdd2501377ca8474b60859bed09cb.svg";
export { ForwardRef as ReactComponent };